import React, { useState } from "react";
import { useDesktop } from "../hooks";
import { motion, AnimatePresence } from "framer-motion";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../services/productsSlice";
import { testimonials } from "../data/testimonials";
import { Coursecontent, Modal } from "../components";
import { getCourses } from "../data/allcourses";

import styled from "styled-components";
import Rating from "@mui/material/Rating";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import check from "../assets/check.svg";
import courseHeaderImg from "../assets/course-image-header.jpg";
import hnetDesktop from "../assets/hnet-desktop.svg";
import "../styles/course.css";

interface courseData {
  course:
    | {
        id: number;
        banner: string;
        title: string;
        duration: string;
        overview: string;
        price: string;
        showPrice: number;
        courseLectures: string;
        description: string[];
        requirements: string[];
        learn: string[];
        courseDetails: string;
        courseDemograph: string[];
        courseContent: {}[];
      }
    | {};
}

type MyParams = {
  courseId: string;
};

const BuyButton = styled.button`
  background: var(--vidomOrange);
  padding: 10px 30px;
  font-size: 1em;
  color: var(--vidomWhite);
  font-weight: 600;
  border-radius: 30px;
  margin-top: 1em;

  @media (min-width: 801px) {
    margin-right: 1em;
  }

  @media (min-width: 1024px) {
    padding: 10px;
  }

  @media (min-width: 1281px) {
    padding: 10px 30px;
  }
`;

const AddButton = styled(BuyButton)`
  color: var(--vidomOrange);
  background: none;
  border: 1px solid var(--vidomOrange);
`;
const ButtonCont = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row !important;

  @media (max-width: 358px) {
    flex-direction: column !important;
  }

  @media (min-width: 801px) {
    justify-content: normal;
    margin-top: 2em;
  }
`;

const Course = () => {
  const { courseId } = useParams<keyof MyParams>() as MyParams;
  const course = getCourses(courseId)!;

  const [value, setValue] = useState(5);
  const [radio, setRadio] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadio(event.target.value);
  };
  const [modal, setmodal] = useState<boolean>(false);

  const dispatch = useDispatch();

  const handleAddToCart = (product: courseData["course"]) => {
    dispatch(addToCart(product));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setmodal(!modal);
    handleAddToCart(course);
  };

  const learningContent = course?.learn.map((learn, i) => (
    <div key={i}>
      <div className="check-container">
        <img
          src={check}
          alt="check"
        />
        <p>{learn}</p>
      </div>
    </div>
  ));
  const courseDescription = course?.description.map((desc, i) => (
    <div key={i}>
      <ul>
        <li>{desc}</li>
      </ul>
    </div>
  ));
  const courseRequirements = course?.requirements.map((req, i) => (
    <div key={i}>
      <ul>
        <li>{req}</li>
      </ul>
    </div>
  ));
  const courseDemograph = course?.courseDemograph.map((dem, i) => (
    <div key={i}>
      <ul>
        <li>{dem}</li>
      </ul>
    </div>
  ));

  const feedbackContent = testimonials.map((feedback, i) => (
    <div key={i}>
      <div className="feedback-content-container">
        <div className="feedback-sub">
          <img
            src={feedback.banner}
            alt="person"
            width="50"
            height="50"
          />
          <div>
            <h4>{feedback.name}</h4>
            <p>{feedback.datePosted}</p>
          </div>
        </div>
        <div>
          <Rating
            name="read-only"
            value={value}
            readOnly
            size="small"
          />
        </div>
      </div>
      <p className="feedback-post">{feedback.post}</p>
    </div>
  ));

  return (
    <>
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0.4 }}
        transition={{ duration: 0.5 }}
        className="course"
      >
        <section className="course-header-img">
          <div className="course-header-img-cont">
            <img
              src={useDesktop() >= 801 ? hnetDesktop : courseHeaderImg}
              alt="course-header"
            />
          </div>

          <div className="course-hero-header-showcase">
            <h1>{course.title}</h1>
            <p>{course.overview}</p>
            <p>{course.duration}</p>
            <p>{course.price}</p>
          </div>
        </section>
        <section className="course-hero-header">
          <div className="course-choice">
            <form onSubmit={handleSubmit}>
              <FormControl required>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={radio}
                  onChange={handleChange}
                >
                  <div className="course-radio-cont">
                    <FormControlLabel
                      value="subscribe"
                      control={<Radio required />}
                      label="Subscribe & Save"
                      checked={radio === "subscribe"}
                    />
                    <p>
                      Get access to all courses from{" "}
                      <span
                        style={{ color: "var(--vidomOrange)", fontWeight: 700 }}
                      >
                        $50
                      </span>
                    </p>
                  </div>
                  <div>
                    <FormControlLabel
                      value="purchase"
                      control={<Radio />}
                      label="Purchase this course only"
                      checked={radio === "purchase"}
                    />
                    <p>
                      <span
                        style={{ color: "var(--vidomOrange)", fontWeight: 700 }}
                      >
                        N10,000
                      </span>
                    </p>
                  </div>
                </RadioGroup>
                <ButtonCont>
                  <BuyButton type="submit">Buy Now</BuyButton>
                  <AddButton>Add to Cart</AddButton>
                </ButtonCont>
              </FormControl>
            </form>
          </div>
          <div className="learning-curve">
            <h2>What You Will Learn:</h2>
            {learningContent}
          </div>
        </section>

        <section className="requirements">
          <h3>Requirements</h3>
          {courseRequirements}
        </section>
        <section className="description">
          <h3>Description</h3>
          {courseDescription}
        </section>

        {useDesktop() >= 801 && (
          <section className="course-demograph">
            <h3>Who this course is for:</h3>
            {courseDemograph}
          </section>
        )}

        <section className="course-content">
          <h3>Course Content</h3>
          <p>{course.courseDetails}</p>

          <Coursecontent />
        </section>
        <AnimatePresence>
          {modal && (
            <motion.section
              className="modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0.4 }}
              transition={{ duration: 0.5 }}
            >
              <Modal
                banner={course.banner}
                title={course.title}
                details={course.courseDetails}
                price={course.price}
                setmodal={setmodal}
              />
            </motion.section>
          )}
        </AnimatePresence>
      </motion.main>
      <article className="feedback">
        <div>
          <h3>Students feedback</h3>
          <p>{course.courseDetails}</p>
        </div>
        <div className="feedback-showcase">{feedbackContent}</div>
      </article>
    </>
  );
};

export default Course;
